import './backGroundTag.css';
const BackGroundTag = (props) => {
  return <h1 className="backgroundtext d-flex justify-content-center"> {props.text} </h1>;
};

export default BackGroundTag;
